import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {requestCreateSurvey, unloadSurvey} from '../../actions/action_survey';
import Loader from '../Loader';
import Title from '../Title';
import SurveyCreateForm from './SurveyCreateForm';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';

class SurveyCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
        };
        this.saveCallback = this.saveCallback.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        this.props.unloadSurvey();
    }

    componentDidUpdate(prevProps) {
        if (this.props.loading !== prevProps.loading && !this.props.loading && this.props.item) {
            this.props.history.push(`/surveys/${this.props.item.id}/edit`);
        }
    }

    onBack() {
        this.props.history.push('/surveys');
    }

    onCancel() {
        this.props.history.push('/surveys');
    }

    saveCallback(data) {
        this.setState({
            item: data,
        }, () => this.props.requestCreateSurvey(data));
    }

    render() {
        const {loading, error} = this.props;
        return (
            <>
                <div className="row">
                    <div className="col-md-2 col-12">
                        <button type="submit" className={classNames('btn btn-outline-primary btn-sm')} onClick={this.onBack}>
                            <Icon icon="arrow_left" /> <FormattedMessage {...messages.surveys.button.surveys} />
                        </button>
                    </div>
                    <div className="col-md-8 col-12">
                        <Title><FormattedMessage {...messages.surveys.title.new} /></Title>
                        {
                            loading && <Loader /> ||
                            <SurveyCreateForm item={this.state.item} error={error} saveCallback={this.saveCallback} onCancel={this.onCancel} />
                        }
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.survey.item,
        loading: state.survey.loading,
        error: state.survey.error,
    };
};

export default connect(mapStateToProps, {requestCreateSurvey, unloadSurvey})(SurveyCreate);
